import { ENDPOINTS } from "config/endpoints";
import { useMutation } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";

interface ResetPasswordInfo {
  newPassword: string;
  code: string;
}

export default function useResetPassword() {
  const resetPassword = (data: ResetPasswordInfo) => {
    const request: Request = {
      url: ENDPOINTS.auth.passwordReset,
      config: {
        method: "post",
        data: data,
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<null>,
    Error,
    ResetPasswordInfo
  >(resetPassword);

  return { data, mutate, ...rest };
}
